// src/components/Intro.js
import { Typewriter } from 'react-simple-typewriter';
import { FaArrowDown } from 'react-icons/fa';

export default function Intro() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-white border-t border-gray-200 text-center px-4"
    >
      <div className="pointer-events-none absolute -top-24 -left-24 w-72 h-72 md:w-96 md:h-96 bg-indigo-100/60 rounded-full blur-3xl animate-pulse-slow" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 w-72 h-72 md:w-96 md:h-96 bg-pink-100/60 rounded-full blur-3xl animate-pulse-slow" />
      <div className="pointer-events-none absolute top-1/3 right-1/4 w-40 h-40 bg-purple-100/50 rounded-full blur-2xl" />

      <div className="relative z-10 flex flex-col items-center animate-fade-up">
        <span className="mb-5 inline-flex items-center gap-2 text-xs md:text-sm font-semibold tracking-widest uppercase text-gray-900 bg-gray-100 px-4 py-1.5 rounded-full shadow-sm">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
          Available for freelance &amp; collabs
        </span>

        <h1 className="text-3xl sm:text-4xl md:text-6xl font-extrabold mb-4 md:mb-6 text-black leading-tight">
          Hi, I'm{' '}
          <span className="bg-gradient-to-r from-indigo-600 via-blue-600 to-pink-600 bg-clip-text text-transparent">
            MOHD SAZID KHAN
          </span>
        </h1>

        <h2 className="text-xl sm:text-2xl md:text-3xl font-medium text-gray-800 mb-8 min-h-[2.5rem]">
          <Typewriter
            words={[
              'Software Engineer 💻',
              'Frontend Expert 🚀',
              'Full Stack Developer 🔧',
              'React + Tailwind Lover 💙',
            ]}
            loop={true}
            cursor
            cursorStyle="|"
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1500}
          />
        </h2>

        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="#products"
            className="px-6 py-3 rounded-full text-sm md:text-base font-semibold text-white bg-gray-900 shadow-md hover:shadow-xl hover:scale-105 transition"
          >
            View My Products
          </a>
          <a
            href="#contact"
            className="px-6 py-3 rounded-full text-sm md:text-base font-semibold text-gray-900 border-2 border-gray-900 hover:bg-gray-900/5 transition"
          >
            Get In Touch
          </a>
        </div>
      </div>

      <a
        href="#about"
        aria-label="Scroll to About"
        className="absolute bottom-8 z-10 text-gray-900/70 hover:text-gray-900 animate-bounce"
      >
        <FaArrowDown size={20} />
      </a>
    </section>
  );
}
